import { useEffect, useState } from 'react';
import './shareButton.sass';

const SHARE_ICON = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 16V3m0 0L7 8m5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" />
  </svg>
);

function getShareUrl(query) {
  const url = new URL('/buscador/', window.location.origin);
  url.searchParams.set('q', query);
  return url.toString();
}

/** Comparte el enlace de una consulta o lo copia cuando Web Share no está disponible. */
export default function ShareButton({ query }) {
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (!status) return undefined;

    const timer = window.setTimeout(() => setStatus(''), 1800);
    return () => window.clearTimeout(timer);
  }, [status]);

  const handleShare = async () => {
    const shareUrl = getShareUrl(query);

    try {
      if (navigator.share) {
        await navigator.share({
          title: query,
          text: `Consulta: ${query}`,
          url: shareUrl,
        });
        setStatus('Compartido');
        return;
      }

      await navigator.clipboard.writeText(shareUrl);
      setStatus('Enlace copiado');
    } catch (error) {
      if (error?.name === 'AbortError') return;

      try {
        await navigator.clipboard.writeText(shareUrl);
        setStatus('Enlace copiado');
      } catch {
        setStatus('No se pudo compartir');
      }
    }
  };

  return (
    <div className="turn-share-action">
      <button
        type="button"
        className="buscador_btn-share"
        onClick={handleShare}
        title="Compartir búsqueda"
        aria-label="Compartir búsqueda"
      >
        {SHARE_ICON}
      </button>
      <span className="turn-share-status" role="status" aria-live="polite">
        {status}
      </span>
    </div>
  );
}
